<template>
  <div class="lighten-page">
    <!-- 页面背景长图 -->
    <img
      style="width: 100%"
      src="../../assets/image/download/lighten/index.jpg"
      alt=""
    />

    <!-- 视频展示区 -->
    <div class="video-div">
      <video
        controls
        loop
        poster="../../assets/image/download/lighten/poster.jpg"
        src="../../assets/image/download/lighten/movie.mp4"
      ></video>
    </div>

    <!-- 顶部下载按钮 -->
    <button class="headerButton" @click="downloadApp">
      <img
        src="../../assets/image/download/lighten/download.png"
        alt="立即下载"
      />
    </button>

    <!-- 微信内引导遮罩 -->
    <section class="mask">
      <img src="../../assets/image/download/mask.png" />
    </section>

    <!-- 底部下载按钮 -->
    <button class="footerButton" @click="downloadApp">
      <img
        src="../../assets/image/download/lighten/download.png"
        alt="立即下载"
      />
    </button>
  </div>
</template>

<script>
import { downloadApp as download } from "./common";

// 未来之光 App 下载地址
const IOS_URL =
  "https://itunes.apple.com/cn/app/%E6%9C%AA%E6%9D%A5%E4%B9%8B%E5%85%89/id1416993897?mt=8";
const ANDROID_PACKAGE = "com.eletell.wow";

export default {
  name: "LightenDownload",
  methods: {
    downloadApp() {
      // 原页面无埋点；安卓统一跳转应用市场
      download({
        iosUrl: IOS_URL,
        androidPackage: ANDROID_PACKAGE,
      });
    },
  },
};
</script>

<style scoped>
.lighten-page {
  position: relative;
}
img {
  display: block;
}
.video-div {
  position: absolute;
  left: 50%;
  top: 11.3%;
  width: 85.3vw;
  height: 48vw;
  margin-left: -42.65vw;
  overflow: hidden;
}
.video-div video {
  width: 100%;
  height: 100%;
}
.headerButton,
.footerButton {
  position: absolute;
  left: 50%;
  padding: 0;
  border: none;
  background: none;
}
.headerButton img,
.footerButton img {
  width: 100%;
}
.headerButton {
  top: 9.2%;
  width: 70.4vw;
  margin-left: -35.2vw;
}
.footerButton {
  bottom: 4%;
  width: 80vw;
  margin-left: -40vw;
}
.mask {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.mask img {
  position: absolute;
  top: 2vw;
  right: 2vw;
  width: 75%;
}
</style>
